import { h } from "preact";
import { useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import { setLoading } from "../store";
import i18n from "../i18n";
import talentsApi from "../api/talents";

import AppFocusLayout from "../components/AppFocusLayout.jsx";
import Button from "../components/Button.jsx";
import TalentHeader from "../components/TalentHeader.jsx";
import TalentDetails from "../components/TalentDetails.jsx";
import TalentShortView from "../components/TalentShortView.jsx";
import TextField from "../components/TextField.jsx";
import { sendError } from "../errors";

export default function SharedTalentPage() {
  const { linkId } = useParams();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(null);
  const loading = useSelector((state) => state.ui.loading);
  const [talent, setTalent] = useState(null);

  const token = new URLSearchParams(location.search).get("token");

  async function handleSubmit(event) {
    event.preventDefault();
    if (!password) {
      setPasswordError(
        i18n.t("pages.shared_talent.password_protection.errors.password_empty")
      );
      return;
    }

    setPasswordError(null);
    dispatch(setLoading(true));
    try {
      setTalent(await talentsApi.fetchSharedProfile(linkId, token, password));
    } catch (err) {
      if (err.message) {
        setPasswordError(err.message);
      } else {
        sendError(err);
      }
    }
    dispatch(setLoading(false));
  }

  if (!talent) {
    return (
      <AppFocusLayout title={i18n.t("pages.titles.shared_talent_page_pw")}>
        <div class="shared-talent-page__password-wrap">
          <form
            action="#"
            method="post"
            onSubmit={handleSubmit}
            class="shared-talent-page__password-form"
          >
            <h1 class="t-h5 t-h5--margin">
              {i18n.t("pages.shared_talent.password_protection.title")}
            </h1>
            <TextField
              name="password"
              label={i18n.t(
                "pages.shared_talent.password_protection.labels.password"
              )}
              error={passwordError}
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              revealable
            />
            <p class="mt-32">
              <Button type="submit" disabled={loading}>
                {i18n.t(
                  "pages.shared_talent.password_protection.submit_button"
                )}
              </Button>
            </p>{" "}
          </form>
        </div>
      </AppFocusLayout>
    );
  }
  return (
    <AppFocusLayout
      ornamented
      title={i18n.t("pages.titles.shared_talent_page", {
        name: talent.data.name,
      })}
    >
      <TalentHeader userData={talent.data}> </TalentHeader>

      <div class="screenPadding">
        <div class="screenPadding__inner mt-48">
          <TalentShortView class="mb-48" user={talent.data} />

          <div class="row">
            <div class="col s12 m8">
              <TalentDetails user={talent.data} />
            </div>
          </div>
        </div>
      </div>
    </AppFocusLayout>
  );
}
